import BcMatchMedia from './bc-match-media';



const matchMedia = new BcMatchMedia();
const state = {current: null};
const getters = {current: state => { return state.current }};
const mutations = {setCurrent: (state, current) => { state.current = current } };



BcMatchMedia.TARGETS.forEach(TARGET => {
  const key = TARGET.key;
  getters[key] = state => { return state.current === key };
});



export default {
  namespaced: true,

  state,
  getters,
  mutations,

  actions: {
    ready() {
      return matchMedia.ready();
    },

    run({dispatch}) {
      matchMedia.on('change', key => {
        dispatch('update');
      });
      dispatch('update');
    },

    update({dispatch, commit, state}) {
      commit('setCurrent', matchMedia.current);
    },

    setBreakPoint({dispatch, commit, state}, breakPoint) {
      matchMedia.setBreakPoint(breakPoint);
      dispatch('run');
    },

    onLoadConfig({dispatch, rootGetters}) {
      dispatch('setBreakPoint', rootGetters['banner/config/breakPoint']);
    },
  },
};



// WEBPACK FOOTER //
// ./src/shared/bc-banner/store/modules/mq.js